/*
 * @Author: bbqin
 * @Date: 2023-03-25 10:51:18
 * @LastEditTime: 2023-03-25 10:51:37
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\animate\animation.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
import { isFunction, isBoolean } from '../../libs/utils';
import classNames from 'classnames';

require('./index.less');

class AnimateRotateIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { showAnimate } = this.state;
        const { title, className, onClick, animation } = this.props;
        return <span className='icon-wrapper'>
            <i
                className={className + ` ${showAnimate ? 'icon-animate-rotate' : ''} `}
                title={title}
                onClick={e => {
                    if (animation) {
                        this.setState({ showAnimate: true });
                        setTimeout(() => {
                            this.setState({ showAnimate: false });
                        }, 300);
                    }
                    isFunction(onClick) && onClick(e);
                }}
            />
        </span>;
    }
}

export default AnimateRotateIcon;